module.exports = __webpack_public_path__ + "static/media/rating.6917758f.png";